import React, { useState, useEffect, useRef} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import MobileNotes from './MobileNotes'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import '../css/NotesArea.css';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import TextareaAutosize from '@mui/material/TextareaAutosize';


import TransitionAlert from './TransitionAlert.js';


import parse from 'html-react-parser'

import {APIAddNote,APIGetNotes} from '../APIS/wupuapAPI.js'
import {getNowMySQL} from '../globals'


import {
  setViewNotes
} from '../slices/dataSlice';

function PopupNotes(props) {
    const dispatch = useDispatch();
    const [opennote, setOpenNote] = useState(false)
    const [notes, setNotes] = useState([])
    const [openalert, setOpenAlert] = useState(false)
    const [alertmsg, setAlertMsg] = useState("")
    const [openaddnote,setOpenAdd] = useState(false)
    const [selnote,setSelNote]=useState(-1)
    const [error,setError] = useState("")
    const [previd,setPrevID] = useState(props.id)
    const auth = useSelector(state => state.auth)
    const {viewNotes} = useSelector(state => state.data)
    const [openmainnote,setOpenMainNote] = useState(props.open)

    const noteTitleRef = useRef(null);
    const noteTextRef = useRef(null);

    useEffect(()=> {
        async function LoadData() {
          if(props.id===previd) {
            return
          }
          setPrevID(props.id)
          try {
            setError("");
            const ret = await APIGetNotes({
              token: auth.token,
              ttp_lead_id: props.data.uid,
            })
            if(ret.status) {
              setNotes(ret.data)
            }
          }catch(err) {
            console.log(`Catch Error in useEffect: ${err.toString()}`,err)
            setNotes([])
            setError(`Error Retrieving Notes ${err.toString()}`)
          }
        }

        if(auth.token > "" && typeof props.data !== 'undefined' && props.data.id > ""  && props.id > "" ) {
          LoadData();
        }
    },[props.data, auth.token, props.data.id, props.data.uid, props.id, previd]);

    const handleCloseNote = () => {
      setOpenNote(false)
    }

    const handleShowNote = (id) => {
      setSelNote(id)
      setOpenNote(true)
    }

    const OpenAlert = (msg) => {
        setAlertMsg(msg)
        setOpenAlert(true)
        return;
    }

    const handleAddNote = async (e) => {
        //console.log(`id set to ${data._id}`)
        const notetitle = noteTitleRef?.current?.value;
        const note = noteTextRef?.current?.value;

        if(notetitle.trim()===""){
          OpenAlert(`Error You Must Enter a Note Title before you can Add a New Note.`)
          return;
        }
        if(note.trim()===""){
          OpenAlert(`Error You Must Enter some Note Text before you can Add a New Note.`)
          return
        }

        const datetime_added = getNowMySQL();
        setNotes(prevNotes => [...prevNotes, {note, title: notetitle, added_by: auth.name, dateadded: datetime_added, datetime_added}])
        const ret = await APIAddNote({
            token: auth.token,
            company_id: props.data.company_id,
            ttp_lead_id: props.data.uid,
            note:note,
            title: notetitle,
            added_by: auth.name,
            datetime_added
        })

        //console.log(ret)
        if(!ret.status)
          OpenAlert(`Error adding note ${ret.err}`)
        else{
          noteTextRef.current.value = ""
          noteTitleRef.current.value = ""
          setOpenAdd(false)
        }
    }

    const cancelAddNote = () => {
        setOpenAdd(false)
          noteTextRef.current.value = ""
          noteTitleRef.current.value = ""
    }
    const closeMainNote = () => {
      setOpenMainNote(false)
      dispatch(setViewNotes(false))
    }
    return (
        <React.Fragment>
            <Dialog
                open={openaddnote}
                onClose={() => setOpenAdd(false)}
                PaperProps={{component: 'paper'}}
                sx={{width: '600px', marginLeft: 'auto', marginRight: 'auto'}}

                maxWidth="xl"
            >
                <DialogTitle>Add New Note</DialogTitle>
                <DialogContent>
                <TextField
                    label='Note Title'
                    id='notetitle'
                    name='notetitle'
                    type='text'
                    placeholder='Enter Note Title'
                    inputRef={noteTitleRef}
                    variant="standard"
                    sx={{fontSize: '10pt', marginBottom:'15px', minwidth: '400px', width: '400px'}}
                    readOnly={false}
                /><br/>
                <TextareaAutosize multiline className='notes' id='notes' placeholder='Enter Notes Here' minRows={8} maxRows={20} rows={8} ref={noteTextRef} style={{width: '500px'}} />
                </DialogContent>
                <DialogActions>
                <Button onClick={cancelAddNote}>Cancel</Button>
                <Button size='sm' variat='outline' onClick={handleAddNote}>Add Note</Button>
                </DialogActions>
            </Dialog>
        {typeof notes !== 'undefined' && selnote >= 0 &&  selnote <= notes.length &&
            <Dialog
                open={(opennote && selnote >= 0)}
                onClose={handleCloseNote}
                maxWidth='800px'
                PaperProps={{component: 'form'}}
            >
                <DialogTitle>Note Details</DialogTitle>
                <DialogContent>
                <DialogContentText >Created on: {`${new Date(notes[selnote].datetime_added??'').toLocaleString()}`} </DialogContentText>
                <DialogContentText >By: {`${notes[selnote].added_by??''}\r\n\n`}<br/></DialogContentText>
                <DialogContentText >Title: {`${notes[selnote].title??''}\r\n`}<br/></DialogContentText>
                <DialogContentText >{error}</DialogContentText>
                <div className='postitnote' >
                {parse((notes[selnote].note??'').replaceAll("\n","<br/>"))}
                </div>
                {/* <TextareaAutosize className='postitnote' maxRows={20} cols={200} rows={20} defaultValue={notes[selnote].note??''} readOnly={true} /> */}
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCloseNote}>Close Note</Button>
                </DialogActions>
            </Dialog>
        }
        <Dialog
                open={viewNotes}
                onClose={() => closeMainNote}
                PaperProps={{component: 'paper'}}
                sx={{width: '600px', marginLeft: 'auto', marginRight: 'auto'}}

                maxWidth="xl"
            >
                <DialogTitle>Notes</DialogTitle>
                <DialogContent>
                  <MobileNotes data={props.data} />
                </DialogContent>
                <DialogActions>
                  <Button size='sm' variat='outline' onClick={() => dispatch(setViewNotes(false)) }>Close</Button>
                  <Button size='sm' variat='outline' onClick={() => setOpenAdd(true)}>Add A New Note</Button>
                </DialogActions>
            <TransitionAlert open={openalert} Close={setOpenAlert} message={alertmsg} />
          </Dialog>



    </React.Fragment>

    )
}

export default PopupNotes;